import React from "react"
// import VerticalLayout from "../../layouts/VerticalLayout"
// import VerticalLayoutDevelopment from "../../layouts/VerticalLayoutDevelopment"
// import VerticalLayoutLanding from "../../layouts/VerticalLayoutLanding"
// import VerticalLayoutLandingCustomer from "../../layouts/VerticalLayoutLandingCustomer"
// import CustomerLayout from "../../layouts/CustomerLayout"
// import FullLayout from "../../layouts/FullpageLayout"
// import FullLayoutRegister from "../../layouts/FullpageLayoutRegister"
// import HorizontalLayout from "../../layouts/HorizontalLayout"
// import themeConfig from "../../configs/themeConfig"

const VerticalLayout = React.lazy(() => import('../../layouts/VerticalLayout'));
const VerticalLayoutDevelopment = React.lazy(() => import('../../layouts/VerticalLayoutDevelopment'));
const VerticalLayoutLanding = React.lazy(() => import('../../layouts/VerticalLayoutLanding'));
const VerticalLayoutLandingCustomer = React.lazy(() => import('../../layouts/VerticalLayoutLandingCustomer'));
const CustomerLayout = React.lazy(() => import('../../layouts/CustomerLayout'));
const FullLayout = React.lazy(() => import('../../layouts/FullpageLayout'));
const FullLayoutRegister = React.lazy(() => import('../../layouts/FullpageLayoutRegister'));
const HorizontalLayout = React.lazy(() => import('../../layouts/HorizontalLayout'));
const themeConfig = React.lazy(() => import('../../configs/themeConfig'));

const layouts = {
  vertical: VerticalLayout,
  verticalLanding: VerticalLayoutLanding,
  verticalLandingCustomer: VerticalLayoutLandingCustomer,//aqui
  verticalDevelopment: VerticalLayoutDevelopment,
  customer: CustomerLayout,
  full: FullLayout,
  fullRegister: FullLayoutRegister,
  horizontal: HorizontalLayout
}

const ContextLayout = React.createContext()

class Layout extends React.Component {
  state = {
    activeLayout: themeConfig.layout,
    width: window.innerWidth,
    lastLayout: null,
    direction: themeConfig.direction
  }

  updateWidth = () => {
    this.setState({
      width: window.innerWidth
    })
  }

  handleWindowResize = () => {
    this.updateWidth()
    if (this.state.activeLayout === "horizontal" && this.state.width <= 1199) {
      this.setState({
        activeLayout: "vertical",
        lastLayout: "horizontal"
      })
    }

    if (this.state.lastLayout === "horizontal" && this.state.width >= 1199) {
      this.setState({
        activeLayout: "horizontal",
        lastLayout: "vertical"
      })
    }
  }

  componentDidMount = () => {
    var cont = 0;
    if (window !== "undefined") {
      window.addEventListener("resize", this.handleWindowResize)
    }
    this.handleDirUpdate()
    if (this.state.activeLayout === "horizontal" && this.state.width <= 1199) {
      this.setState({
        activeLayout: "vertical"
      })
    } else if (
      themeConfig.layout === "horizontal" &&
      this.state.width >= 1200
    ) {
      this.setState({
        activeLayout: "horizontal"
      })
    } else {
      this.setState({
        activeLayout: "vertical"
      })
    }
  }

  componentDidUpdate() {
    this.handleDirUpdate()
  }

  handleDirUpdate = () => {
    let dir = this.state.direction
    if (dir === "rtl")
      document.getElementsByTagName("html")[0].setAttribute("dir", "rtl")
    else document.getElementsByTagName("html")[0].setAttribute("dir", "ltr")
  }



  render() {
    const { children } = this.props
    return (
      <ContextLayout.Provider
        value={{
          state: this.state,
          fullLayout: layouts["full"],
          fullLayoutRegister: layouts["fullRegister"],
          VerticalLayout: layouts["vertical"],
          VerticalLayoutLanding:  layouts["verticalLanding"],
          VerticalLayoutLandingCustomer:  layouts["verticalLandingCustomer"],
          VerticalLayoutDevelopment: layouts["verticalDevelopment"],
          CustomerLayout: layouts["customer"],
          horizontalLayout: layouts["horizontal"],
          switchLayout: layout => {
            this.setState({ activeLayout: layouts["full"] })
          },
          switchDir: dir => {
            this.setState({ direction: dir })
          }
        }}
      >
        {children}
      </ContextLayout.Provider>
    )
  }
}

export { Layout, ContextLayout }
